import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import Paragraph from 'components/Paragraph';
import { Modal } from 'apps/modals/views/modal';

import {
  ModalTitle,
  ModalSubtitle,
  FullWidthDivider,
} from 'legacyComponents/styled/lib';

import { List, ContainerInfo, ContButtons, ButtonStyled } from './styles';

@withNamespaces()
@observer
export class ModalExpired extends Modal {
  render() {
    return (
      <>
        <ModalTitle variant='destructive' level={2}>
          <Trans>Free Trial has expired</Trans>
        </ModalTitle>
        <ModalSubtitle level={3}>
          <Trans>
            Your free trial has now expired. As you know, to continue
            collaborating privately on Wikifactory you will need to purchase a
            subscription.
          </Trans>
        </ModalSubtitle>
        <FullWidthDivider marginTop='1rem' />
        <ContainerInfo align='center'>
          <Paragraph>
            <strong>
              <Trans>In the meantime, you have the following options</Trans>:
            </strong>
          </Paragraph>
          <List>
            <li>
              - <Trans>Convert your private project to a public project</Trans>
            </li>
            <li>
              - <Trans>Download your private project&apos;s latest files</Trans>
            </li>
          </List>
          <Paragraph>
            <Trans>
              Simply message us via the built in chat in the bottom right
              corner, to action any of these within 24h.
            </Trans>
          </Paragraph>
          <ContButtons>
            <ButtonStyled
              text={<Trans>Maybe later</Trans>}
              variant='secondary'
              onClick={this.props.clickCancel}
              outline
            />
            <ButtonStyled
              text={<Trans>Purchase subscription</Trans>}
              onClick={this.props.clickPurchaseButton}
              strong
            />
          </ContButtons>
        </ContainerInfo>
      </>
    );
  }
}

ModalExpired.propTypes = {
  fadeIn: PropTypes.func,
  clickCancel: PropTypes.func,
};
